import { render, staticRenderFns } from "./dropdown-menu.vue?vue&type=template&id=24905b4e&scoped=true&"
import script from "./dropdown-menu.vue?vue&type=script&lang=js&"
export * from "./dropdown-menu.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-menu.vue?vue&type=style&index=0&id=24905b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24905b4e",
  null
  
)

export default component.exports